module.exports = __webpack_public_path__ + "static/media/nishant_agte.0801e2f4.png";